import { currentSnackbarState } from '@databases/snackbar/snackbar';

import { messages } from './i18n';
import {
  ShowRestrictionsBannerForSingleUserProps,
  ShowRestrictionsBannerForMultipleUsersProps,
  ShowBannerForRestrictedUsers,
} from './types';
import { getDisplayNameForUsers } from './utils/getDisplayNameForUsers';

// This will be deprecated once `databases-frontend-mentions-notifications-flag` is fully rolled out
export const showBannerForRestrictedUsers = ({
  users,
  formatMessage,
}: ShowBannerForRestrictedUsers) => {
  switch (users.length) {
    case 0:
      return;
    case 1:
      showRestrictionsBannerForSingleUser({
        formatMessage,
        displayName: users[0].displayName,
        permissions: users[0].permissions,
      });
      break;
    case 2:
      showRestrictionsBannerForTwoUsers({
        formatMessage,
        users,
      });
      break;
    default:
      showRestrictionsBannerForMultipleUsers({
        formatMessage,
        users,
      });
      break;
  }
};

export const showRestrictionsBannerForSingleUser = ({
  formatMessage,
  displayName,
  permissions,
}: ShowRestrictionsBannerForSingleUserProps) => {
  const messageKey =
    permissions.isSpaceRestricted || permissions.isParentDatabaseRestricted
      ? 'mention-notification.permission-space-or-parent-database-restriction-one-user'
      : 'mention-notification.permission-database-restriction-one-user';

  currentSnackbarState.setMessage(
    formatMessage(messages[messageKey], {
      displayName:
        displayName ||
        formatMessage(
          messages['mention-notification.permission-database-restriction-fallback-user']
        ),
    }),
    {
      id: messageKey,
      type: 'error',
      showCloseButton: true,
    }
  );
};

export const showRestrictionsBannerForTwoUsers = ({
  formatMessage,
  users,
}: ShowRestrictionsBannerForMultipleUsersProps) => {
  const { displayName, somebodyElse } = getDisplayNameForUsers({ users });

  currentSnackbarState.setMessage(
    formatMessage(
      messages['mention-notification.permission-database-restriction-two-users'],
      {
        displayName,
        somebodyElse,
      }
    ),
    {
      id: 'mention-notification.permission-database-restriction-two-users',
      type: 'error',
      showCloseButton: true,
    }
  );
};

export const showRestrictionsBannerForMultipleUsers = ({
  formatMessage,
  users,
}: ShowRestrictionsBannerForMultipleUsersProps) => {
  const { displayNamesCount, displayName, somebodyElse } = getDisplayNameForUsers({
    users,
  });

  currentSnackbarState.setMessage(
    formatMessage(
      messages[
        'mention-notification.permission-database-restriction-three-or-more-users'
      ],
      {
        displayName,
        somebodyElse,
        numOthers: (displayNamesCount - 2).toString(),
      }
    ),
    {
      id: 'mention-notification.permission-database-restriction-three-or-more-users',
      type: 'error',
      showCloseButton: true,
    }
  );
};
